import { render, staticRenderFns } from "./SchoolBox.vue?vue&type=template&id=5890aa52&"
import script from "./SchoolBox.vue?vue&type=script&lang=js&"
export * from "./SchoolBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports